import React from 'react'

const IconCollection = () => (
  <svg width="15px" height="15px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
      <path
        d="M13.5,10.5 L13.5,21.5 L2.5,21.5 L2.5,10.5 L13.5,10.5 Z M11.5,12.5 L4.5,12.5 L4.5,19.5 L11.5,19.5 L11.5,12.5 Z M17.5,6.5 L17.5,17.5 L15.5,17.5 L15.5,8.5 L6.5,8.5 L6.5,6.5 L17.5,6.5 Z M21.5,2.5 L21.5,13.5 L19.5,13.5 L19.5,4.5 L10.5,4.5 L10.5,2.5 L21.5,2.5 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconCollection
